export function PresentationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2a1 1 0 011 1v1h5a3 3 0 013 3v8a3 3 0 01-3 3h-2.586l1.293 1.293a1 1 0 01-1.414 1.414L12.586 18h-1.172l-2.707 2.707a1 1 0 01-1.414-1.414L8.586 18H6a3 3 0 01-3-3V7a3 3 0 013-3h5V3a1 1 0 011-1zm1 14h5a1 1 0 001-1V7a1 1 0 00-1-1H6a1 1 0 00-1 1v8a1 1 0 001 1h7zm3.8-6.4a1 1 0 10-1.6-1.2l-2.432 3.243-2.213-1.475a1 1 0 00-1.262.125l-2 2a1 1 0 101.414 1.414l1.42-1.42 2.318 1.545A1 1 0 0013.8 13.6l3-4z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
